import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Guide from './Guide';
import usePublicLink from '../../apps/PublicLink/usePublicLink';
var GUIDE_LOCAL_STORAGE_KEY = 'ECR.RA.GuideCompleted';

var GuideProvider = function GuideProvider(_ref) {
  var guide = _ref.guide;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      toggle = _React$useState2[1];

  var _usePublicLink = usePublicLink(),
      publicId = _usePublicLink.publicId;

  var localStorageKey = guide && guide.localStorageKey ? guide.localStorageKey : GUIDE_LOCAL_STORAGE_KEY;
  React.useEffect(function () {
    if (publicId) return;
    if (!guide) return;
    var guideCompleted = localStorage.getItem(localStorageKey);
    if (!guideCompleted) toggle(true);
  }, [toggle, guide, localStorageKey, publicId]);
  return React.createElement(React.Fragment, null, open && React.createElement(Guide, Object.assign({}, guide, {
    onFinish: function onFinish() {
      toggle(false);
      localStorage.setItem(localStorageKey, 'true');
      if (guide.onFinish) guide.onFinish();
    },
    onCancel: function onCancel() {
      toggle(false);
      localStorage.setItem(localStorageKey, 'true');
      if (guide.onFinish) guide.onFinish();
    }
  })));
};

export default GuideProvider;